module.exports = __webpack_public_path__ + "img/australia-neoplasm-male.b3f69ff0.png";